/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */

export async function loadMonthlyRecordDetails(searchFilter) {
  return await api
    .post(`/auth/attendance/monthlyrecord`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadAttendenceAPI(searchFilter) {
  return await api
    .post(`/auth/attendance/getattendance`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadCheckinOutAPI(searchFilter) {
  return await api
    .post(`/protected/getaction`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
const remotes = {
  loadMonthlyRecordDetails,
  loadAttendenceAPI,
  loadCheckinOutAPI
};

export default remotes;
